module.exports = __webpack_public_path__ + "img/greg-smc.d51e3f6a.jpg";